import { render, staticRenderFns } from "./AnswerChart.vue?vue&type=template&id=d5fa2058&scoped=true&"
import script from "./AnswerChart.vue?vue&type=script&lang=ts&"
export * from "./AnswerChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fa2058",
  null
  
)

export default component.exports